import { Button } from "@components/ui/button";
import * as Select from "@radix-ui/react-select";
import { useEffect, useState } from "react";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import { IoAdd } from "react-icons/io5";
import DashboardFilters from "@pages/Dashboard/filters";
import { clearFilters } from "@redux/slices/filter";

import {
  deleteTargetMarket,
  getAllTargetMarkets,
  getTargetMarketsById,
  saveFiltersState,
  updateTargetMarketStatus,
} from "@redux/slices/filter";
import { Dispatch } from "react";
import useAuth from "@hooks/useAuth";
import { useNavigate } from "react-router";
import LoadingScreen from "@components/LoadingScreen";
import { Archive, ArchiveRestore, Copy, Trash2 } from "lucide-react";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store";
import Swal from "sweetalert2";
import { useDispatch} from "react-redux";

export interface TargetMarket {
  id: number;
  status: string;
  created_at: Date;
  name: string;
}

const TargetMarkets = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [closeModal, setCloseModal] = useState(false);
  const [targetMarkets, setTargetMarkets] = useState<TargetMarket[] | null>(
    null
  );
  const [filteredMarkets, setFilteredMarkets] = useState<TargetMarket[] | null>(
    null
  );
  const [selectedValue, setSelectedValue] = useState("current");
  const [searchQuery, setSearchQuery] = useState<string>(""); // Search query state

  const navigate = useNavigate();
  const { user } = useAuth();
  console.log(user);
  const selectedUserId = useSelector(
    (state: RootState) => state.user.selectedUserId
  );

  useEffect(() => {
    setLoading(true);
    getData();
    console.log("first");
  }, [showModal,closeModal, selectedValue, user]);

  const handleChange = (value: any) => {
    setSelectedValue(value);
    console.log("Selected value:", value);
  };

  const getData = async () => {
    console.log("addddddd", selectedUserId);
    const targetMarketsArray =
      user?.role !== "admin"
        ? await getTargetMarketsById(user?.id)
        : selectedUserId !== null
        ? await getTargetMarketsById(selectedUserId)
        : window.location.pathname.split("/")[2] == "admin"
        ? await getAllTargetMarkets()
        : await getTargetMarketsById(window.location.pathname.split("/")[2]);

    const filteredData = targetMarketsArray?.filter(
      (i) => i.status === selectedValue
    );
    const sortedData = filteredData?.sort((a, b) => {
      const dateA = new Date(a.created_at).getTime();
      const dateB = new Date(b.created_at).getTime();
      return dateA - dateB;
    });

    if (sortedData) {
      setTargetMarkets(sortedData as TargetMarket[]);
      applySearchFilter(searchQuery, sortedData as TargetMarket[]);
    }
    console.log(sortedData);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value;
    setSearchQuery(query);
    applySearchFilter(query, targetMarkets);
  };

  const applySearchFilter = (query: string, data: TargetMarket[] | null) => {
    if (!data) return;

    const filtered = data.filter((market) =>
      market.name
        ? market.name.toLowerCase().includes(query.toLowerCase())
        : `TM ${market.id}`.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredMarkets(filtered);
  };

  const dispatch = useDispatch();

  const data = useSelector((state: RootState) => state.filter);

  const handleClearDatas = () => {
    dispatch(clearFilters(data));
  };

  const handleOpenModal = () => {
    handleClearDatas();
    setShowModal(true);
    navigate(`/targetMarkets/${user?.role}/?filter=favourites`);
  };

  const handleCloseModal = () => {
    setLoading(true);
    getData();
    setShowModal(false);
  };

  const handleStatusUpdate = async (id: number, val: string) => {
    setLoading(true);
    console.log(id, val);
    const data = await updateTargetMarketStatus(id, val);
    getData();
    console.log(data);
  };

  const handleDelete = async (id: any) => {
    await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#1cb5af",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        await deleteTargetMarket(id);
        setLoading(true);
        await getData();
        setLoading(false);
      }
    });
  };
  const handleClearData = () => {};
  const copyTextToClipboard = async (val: any) => {
    setLoading(true);
    await saveFiltersState(
      user?.id,
      JSON.parse(val.filters),
      `${val?.name !== null || "" ? val?.name : "TM " + val?.id} copy`,
      handleClearData
    );
    getData();
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <div className="md:flex justify-between items-center my-7">
            <div className="md:me-2 md:w-72 md:mb-0 mb-4">
              {user?.role !== "admin" && (
                <Select.Root value={selectedValue} onValueChange={handleChange}>
                  <SelectTrigger
                    className="SelectTrigger bg-white border-none"
                    aria-label="Food"
                  >
                    <SelectValue placeholder="Select" />
                  </SelectTrigger>
                  <SelectContent className="SelectContent">
                    <SelectItem value="current">Current</SelectItem>
                    <SelectItem value="archeived">Archived</SelectItem>
                  </SelectContent>
                </Select.Root>
              )}
            </div>
            <div className="sm:flex items-center">
              <div className="relative">
                <input
                  className="appearance-none placeholder:text-[#B5B7C0] placeholder:text-sm placeholder:ps-1 border-0 pl-10 border-[#e2e8f0] bg-white shadow-sm  transition-colors rounded-md w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none"
                  id="search"
                  type="text"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <div className="absolute left-0 inset-y-0 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 ml-3 text-gray-400 hover:text-gray-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#71717A"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
              </div>
              {user?.role !== "admin" && (
                <Button
                  className="sm:ms-2 sm:mt-0 mt-4 bg-[#1CB5AF]"
                  onClick={handleOpenModal}
                >
                  <IoAdd size={20} className="me-2" />
                  Add Target Market
                </Button>
              )}
            </div>
          </div>

          <div className="lg:flex gap-5 flex-wrap">
            {filteredMarkets && filteredMarkets?.length > 0 ? (
              filteredMarkets?.map((val, index) => (
                <div
                  key={val.id}
                  className="bg-white rounded-2xl p-8 lg:w-[23.55%]"
                >
                  <div className="flex justify-between items-center mb-4">
                    <p className="uppercase text-[#71717A] text-xs">
                      Target Market
                    </p>
                    <div className="flex items-center">
                      {user?.role !== "admin" &&
                        (val.status === "current" ? (
                          <Archive
                            size={16}
                            className="cursor-pointer text-[#71717A] "
                            onClick={() =>
                              handleStatusUpdate(val?.id, "archeived")
                            }
                          />
                        ) : (
                          <ArchiveRestore
                            size={16}
                            className="cursor-pointer text-[#71717A] "
                            onClick={() =>
                              handleStatusUpdate(val?.id, "current")
                            }
                          />
                        ))}
                      {user?.role !== "admin" && (
                        <div className="flex items-center">
                          <Copy
                            size={16}
                            className="cursor-pointer text-[#71717A]  mx-2"
                            onClick={() => copyTextToClipboard(val)}
                          />
                          <Trash2
                            size={16}
                            className="cursor-pointer text-[#71717A] "
                            onClick={() => handleDelete(val.id)}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <h5
                    className="text-2xl font-bold cursor-pointer"
                    onClick={() =>
                      navigate(`/targetMarkets/targetMarketDetail/${val?.id}`)
                    }
                  >
                    {val?.name !== "" ? val?.name : "TM " + val?.id}
                  </h5>
                </div>
              ))
            ) : (
              <div className="text-center my-24 w-full">
                <h5 className="text-gray font-bold mb-2">
                  You have no target markets yet
                </h5>
                <p className="text-[#71717A]">
                  Learn how to create optimal target markets with the related{" "}
                  <br className="sm:block hidden" /> Help centre articles
                </p>
              </div>
            )}
          </div>
          <DashboardFilters
            handleCloseModal={handleCloseModal}
            showModal={showModal}
            setCloseModal={setCloseModal}
          />
        </div>
      )}
    </>
  );
};

export default TargetMarkets;
